export default "__VITE_ASSET__MRkRUhlhqYk6wXjZrGkzSA__ 480w, __VITE_ASSET__hBLucboj$p4GA1VBUKy2jQ__ 745w";